import { render, staticRenderFns } from "./role-permission.vue?vue&type=template&id=5158f828"
import script from "./role-permission.vue?vue&type=script&lang=js"
export * from "./role-permission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports